{
  "Received": "Nhận token",
  "Transferred": "Thanh toán",
  "TransferredWithBonus": "Thanh toán",
  "ExchangedIn": "Quy đổi",
  "BuyOrderCompleted": "Mua token",
  "SellOrderReserved": "Bán token",
  "SellOrderRefunded": "Bán token",
  "SellOrderRebated": "Bán token",
  "Credited": "Tăng số dư khả dụng",
  "DebitCompleted": "Giảm số dư khả dụng",
  "BonusActivityRewarded": "Phần thưởng",
  "SellOrderCompleted": "Bán token"
}
